export default __webpack_public_path__ + "62514b73306a85e5f85119b90af457c5.png";